let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c1qtf")).then(() => parcelRequire('5KpQH'));